import { nextSunday } from 'date-fns';

export function isChristmasTime() {
  const currentYear = new Date().getFullYear();
  const christmasTimeStart = nextSunday(new Date(currentYear, 10, 26, 0, 0, 0, 0)).getTime();
  const christmasTimeEnd = new Date(currentYear + 1, 1, 6, 0, 0, 0, 0).getTime();
  const today = new Date().getTime();
  return today > christmasTimeStart && today < christmasTimeEnd;
}
